import {
  Box,
  Button,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import EventCard from "./EventCard";
import SearchIcon from "@mui/icons-material/Search";
import ThriveModal from "../../common/ThriveModal";

import { NavLink } from "react-router-dom";
import { SurveyContent } from "../../Survey/PublicEventSurvey";
import CloseIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../../../utils/networking";
import LargeScreenNotice from "../../common/LargeScreenNotice";
import ListPager from "../../common/ListPager";
import { usePagedList } from "../../../utils/usePagedList";

const EVENTS_PER_PAGE = 10;

const PastEvents = (props: any) => {
  const [availableEvents, setAvailableEvents] = useState<any[]>([]);
  const [displayEvents, setDisplayEvents] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [invitationOpen, setInvitationOpen] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);

  const [surveyResults, setSurveyResults] = useState<any>([]);
  const [surveyResultOpen, setSurveyResultOpen] = useState(false);
  const [openSurvey, setOpenSurvey] = useState("");

  useEffect(() => {
    axiosInstance.get(`/events/past`).then((res) => {
      setAvailableEvents(res.data.events);
      setDisplayEvents(res.data.events);
    });
  }, []);

  useEffect(() => {
    axiosInstance
      .get(`/survey/results?survey_id=65412693f9ecc07bf529219f`)
      .then((res) => {
        setSurveyResults(res.data.results);
      });
  }, []);

  const handleEventSearch = (e: any) => {
    setSearchTerm(e.target.value);
    setDisplayEvents(
      availableEvents.filter((event: any) => {
        return ((event.name?.text || "") + (event.description?.text || ""))
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      })
    );
  };

  const handleSendInvitation = () => {
    setInvitationOpen(false);
    setEditorOpen(true);
  };

  // Every search keystroke starts again at page 1.
  const paged = usePagedList(displayEvents, EVENTS_PER_PAGE, [searchTerm]);
  const listTopRef = useRef<HTMLDivElement>(null);
  // A page picked from the bottom pager starts at its first event.
  const goToPage = (page: number) => {
    paged.setPage(page);
    const listTop = listTopRef.current;
    if (listTop && listTop.getBoundingClientRect().top < 0) {
      listTop.scrollIntoView({ block: "start" });
    }
  };
  const pager = (
    <ListPager
      page={paged.page}
      pageCount={paged.pageCount}
      from={paged.from}
      to={paged.to}
      total={paged.total}
      onPageChange={goToPage}
      itemLabel="events"
    />
  );

  let mappedResults: any = {};

  if (surveyResults.length != 0) {
    surveyResults.forEach((result: any) => {
      let surveyTitle = result.survey_result.q1.split(" - ")[1];
      if (mappedResults[surveyTitle]) {
        mappedResults[surveyTitle].push(result);
      } else {
        mappedResults[surveyTitle] = [result];
      }
    });
  }

  return (
    <Box>
      <LargeScreenNotice pageKey="past-events" />
      <Stack direction={"row"} spacing={2}>
        {/* <Box sx={{ width: "30%" }}>
          <Stack>
            <Box>Tag Search Bar</Box>

            <Box>Tag List</Box>
          </Stack>
        </Box> */}

        <Box sx={{ width: "100%" }}>
          <Stack spacing={2}>
            <Typography variant="h3">Previous Events</Typography>
            <NavLink to="/dashboard/events">
              <Button sx={{ color: "#b3197a" }}>See Upcoming Events</Button>
            </NavLink>
            <TextField
              label="Search Events..."
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={handleEventSearch}
            ></TextField>

            {/* <Box>Event Category</Box> */}

            <Stack ref={listTopRef} spacing={2}>
              {pager}
              <Stack>
                {paged.pageItems.map((event: any, index: number) => {
                  return (
                    <EventCard
                      key={String(event._id ?? index)}
                      event={event}
                      setInvitationOpen={setInvitationOpen}
                      setSelectedEvent={setSelectedEvent}
                      surveyResults={mappedResults[event.name.text]}
                      openSurvey={openSurvey}
                      setOpenSurvey={setOpenSurvey}
                      setSurveyResultOpen={setSurveyResultOpen}
                    ></EventCard>
                  );
                })}
              </Stack>
              {pager}
            </Stack>
          </Stack>
        </Box>
      </Stack>

      <ThriveModal
        open={surveyResultOpen}
        setOpen={setSurveyResultOpen}
        contentComponent={
          <>
            <Box
              sx={{
                textAlign: "center",
                backgroundColor: "#9E1F63FF",
                padding: "3px",
                margin: 0,
                color: "white",
                borderRadius: "5px 5px 0 0",
                marginBottom: "20px",
              }}
            >
              <Typography sx={{ display: "inline-block" }} variant="h4">
                Event Survey Result
              </Typography>
              <Box
                sx={{ display: "inline", float: "right", cursor: "pointer" }}
                onClick={() => {
                  setSurveyResultOpen(false);
                }}
              >
                <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
              </Box>
            </Box>
            <Box sx={{ overflowY: "scroll", height: { xs: 470, md: 570 } }}>
              <SurveyContent survey_id={openSurvey}></SurveyContent>
            </Box>
          </>
        }
      ></ThriveModal>
    </Box>
  );
};

export default PastEvents;
